import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import store from "../../../../redux/store";
import * as constants from "../constants";
import { ConnectionCheck } from "./ConnectionCheck";
import { initialize } from "./ice";
import { softphone } from "./softphone";
import { callSIPEventEngine, eventEngineDataObject } from "../helpers";
import useUserMediaStatus from "./useUserMediaStatus";
import ConfigurationToastMessage from "../../Configuration/pages/Configuration/Util/ConfigurationToastMessage";
import { setSnackbar } from "../../../../redux/snackbar";
import broadcastEvents from "./broadcast-events";


export default function AlertDialog() {
  const [open, setOpen] = React.useState(true);
  const dispatch = useDispatch();

  function handleClose() {
    dispatch({
      type: "onSetTickerState",
      payload: { is_sip_user_acknowledged: true },
    });
    setOpen(false);
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Use WebRTC SIP Phone service?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            By accepting the Webrtc SIP phone shall be enabled in your browser
            window.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export const getSIPUserAgentSettings = (agent) => {
  const settings = {
    status: true,
    log_level: "LOG_LEVEL_DEBUG",
    videoEnabled: false,
    autoRegister: true,
    displayName: `${store.getState().auth.kamailio_username}`,
    password: `${store.getState().auth.kamailio_password}`,
    outboundProxy: `${store.getState().auth.kamailio_wss_domain}`,
    sipUri: `sip:${agent.phone}`,
    playRingtone: true,
    ringtone: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    iceServers: window?.iceServers,

    pingUser: {
      log_level: "LOG_LEVEL_DEBUG",
      videoEnabled: false,
      autoRegister: true,
      displayName: "lokendra",
      password: "lokendra",
      outboundProxy: `${store.getState().auth.user.kamailio_wss_domain}`,
      sipUri: "sip:lokendra_lodha@kamailio2.intra.knowlarity.com",
      playRingtone: true,
      ringtone: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    },
  };

  return settings;
};

export const askSIPPermission = (props) => {};

export const SIPPhone = (props) => {
  const dispatch = useDispatch();
  const userMediaEnabled = useUserMediaStatus();

  const [toastInfo, setToastInfo] = useState({
    open: false,
    severity: "info",
    snackbarMessage: "",
  });

  const is_sip_user_acknowledged = useSelector((state) => {
    return state.ticker.is_sip_user_acknowledged;
  });

  const is_sso = useSelector((state) => {
    return state.auth.is_sso;
  });

  const phone_switch_state = useSelector((store) => {
    return store.ticker.phone_switch_state;
  });

  const phone_switch_state_changed = useSelector((store) => {
    return store.ticker.phone_switch_state_changed;
  });

  const sipAgent = useSelector((store) => {
    return store.ticker.sipAgent;
  });

  const sip_command = useSelector((store) => {
    return store.ticker.sip_command;
  });

  const is_mpls = useSelector((store) => {
    return store.auth.is_mpls;
  });

  const sip_retry = useSelector((state) => {
    return state.ticker.sip_retry;
  });

  const user = useSelector((state) => {
    return state.ticker.sip_user;
  });

  const iceServers = window.iceServers;

  const sip_event_info = useSelector((state) => state.ticker.sip_event_info);

  const handleCloseSnackbar = () => {
    setToastInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const notifyCallEvent = (event) => {
    if (!event) return;
    switch (event.type) {
      case "ongoing": {
        dispatch({
          type: "onCallStateChange",
          payload: { sip_call_event:event,sip_call_event_type: "ongoing" },
        });
        //we do not use this - and instead use knowlarity events when - a call is ansered by sip agent using accept btn on call initiate screen.
        break;
      }
      case "notification" : {
        dispatch(setSnackbar(true, event.payload.variant, event.payload.message));
        break;
      }
      case "registered": {
        dispatch({
          type: "onSetTickerState",
          payload: {
            sip_connected: true,
            sip_tried: true,
            sip_user: event.payload.user,
          },
        });
        break;
      }

      case "hangup":
      case "hangup_done": {
        dispatch({
          type: "onSetTickerState",
          payload: {
            call_state: constants.CALL_STATES.CALL_HANGUP,
            hangup_reason: "self",
          },
        });
        dispatch({ type: "Close", payload: {} });
        dispatch({ type: "onCallEvent", payload: {} });
        dispatch({
          type: "onCallStateChange",
          payload: { sip_call_event_type: null, sip_call_event: event },
        });
        break;
      }

      case "hangup_done_with_error": {
        dispatch({
          type: "onSetTickerState",
          payload: {
            call_state: constants.CALL_STATES.CALL_HANGUP,
            hangup_reason: "self",
          },
        });
        break;
      }

      case "register_error": {
        dispatch({
          type: "onSetTickerState",
          payload: { sip_connected: false, sip_tried: true },
        });
        break;
      }

      case "rejected": {
        dispatch({
          type: "onSetTickerState",
          payload: { call_state: constants.CALL_STATES.CALL_HANGUP },
        });
        dispatch({ type: "Close", payload: {} });
        dispatch({ type: "onCallEvent", payload: {} });
        break;
      }

      case "error_accept_reject": {
        dispatch({
          type: "onSetTickerState",
          payload: { call_state: constants.CALL_STATES.CALL_HANGUP },
        });
        dispatch({ type: "Close", payload: {} });
        dispatch({ type: "onCallEvent", payload: {} });
        break;
      }

      case "unregistered": {
        dispatch({
          type: "onSetTickerState",
          payload: { sip_connected: false, sip_tried: true },
        });
        dispatch({ type: "Close", payload: {} });
        break;
      }

      case "invited": {     
        if(!userMediaEnabled) {
          broadcastEvents("MICROPHONE", '', '');
          setToastInfo((prevState) => ({
            ...prevState,
            open: true,
            snackbarMessage: `Error! Microphone not detected. Connect Microphone to answer calls.`,
            severity: "error",
          }));
          notifyCallEvent({ type: "register_error" });
          return;
        }     
        dispatch({
          type: "onCallStateChange",
          payload: { sip_call_event_type: event.type, sip_call_event: event },
        });
        break;
      }

      case "muted": {
        const payload = {};
        payload[constants.CALL_COMMANDS.MUTE] = constants.MUTE_STATES.ON_MUTE;
        dispatch({ type: "onCallStateChange", payload: payload });
        break;
      }

      case "unmuted": {
        const payload = {};
        payload[constants.CALL_COMMANDS.MUTE] =
          constants.MUTE_STATES.NOT_ON_MUTE;
        dispatch({ type: "onCallStateChange", payload: payload });
        break;
      }

      default:
        return;
    }
  };

  let additionalInfo = '';

  const eventBasedNotifyCallEvent = (event) => {
    if (!event) return;

    switch (event.type) {
      case "ongoing": {
        //we do not use this - and instead use knowlarity events when - a call is ansered by sip agent using accept btn on call initiate screen.
        dispatch((dispatch, getState) => {
          const eventCustomData = eventEngineDataObject({ agent_ack: { tried: true } }, getState().ticker.sip_event_info.invited);
          
          eventCustomData && callSIPEventEngine(Object.values(eventCustomData)[0], dispatch);
          setTimeout(() => {
            dispatch((dispatch, getState) => {
              const eventCustomData = eventEngineDataObject(event.event_info, getState().ticker.sip_event_info.invited);
              const updatedSipEventInfo = { ...getState().ticker.sip_event_info, ...event.event_info };

              // const neweventCustomData = Object.values(eventCustomData)[0]['event_type'] == 'CUSTOMER_CALL' ? { ...Object.values(eventCustomData)[0], variable_current_application: 'att_xfer' } : Object.values(eventCustomData)[0];
              dispatch({
                type: "onCallStateChange",
                payload: { sip_event_info: updatedSipEventInfo,sip_call_event_type: "ongoing" },
              });
              eventCustomData && callSIPEventEngine(Object.values(eventCustomData)[0], dispatch);
            });
          }, 200);
        });
        break;
      }
      case "notification" : {
        dispatch(setSnackbar(true, event.payload.variant, event.payload.message));
        break;
      }
      case "info": {
        if(event?.event_info['info'].additionalinfo?.split(",")[0].includes('legcanswer')) {
          sessionStorage.setItem('legcuuid', /legcuuid:([^,]+)/.exec(event?.event_info['info'].additionalinfo)[1]);
        } 
        if(event?.event_info['info'].additionalinfo?.split(",")[0].includes('attxferOriginate')) {
           sessionStorage.setItem('legcuuid', /legcuuid:([^,]+)/.exec(event?.event_info['info'].additionalinfo)[1]);
          return;
        } 
        dispatch((dispatch, getState) => {
          if(!additionalInfo && getState().ticker.sip_event_info.info) {
            additionalInfo = getState().ticker.sip_event_info.info.additionalinfo.split(",").reduce((obj, pair) => {
              let [key, value] = pair.split(":");
              obj[key] = value;
              return obj;
            }, {});
          }
          
          const eventCustomData = eventEngineDataObject(event.event_info, getState().ticker.sip_event_info.invited, additionalInfo['legbuuid'])

          const updatedSipEventInfo = { ...getState().ticker.sip_event_info, ...event.event_info };

          dispatch({
            type: "onCallStateChange",
            payload: { sip_event_info: updatedSipEventInfo },
          });
           eventCustomData && callSIPEventEngine(Object.values(eventCustomData)[0], dispatch);

        })
        break;
      }
      case "registered": {
        dispatch({
          type: "onSetTickerState",
          payload: {
            sip_connected: true,
            sip_tried: true,
            sip_user: event?.payload?.user,
          },
        });
        break;
      }

      case "hangup":
      case "hangup_done": {
        dispatch((dispatch, getState) => {
          const eventCustomData = eventEngineDataObject({ hangup: {} }, getState().ticker.sip_event_info.invited);
           eventCustomData && callSIPEventEngine(Object.values(eventCustomData)[0], dispatch);
           additionalInfo = '';
           sessionStorage.removeItem('legcuuid');
          dispatch({
            type: "onSetTickerState",
            payload: {
              call_state: constants.CALL_STATES.CALL_HANGUP,
              hangup_reason: "self",
              // sip_event_info: {}
            },
          });
          dispatch({
            type: "onCallStateChange",
            payload: { sip_call_event_type: null, sip_call_event: event },
          });
        });
        break;
      }

      case "hangup_done_with_error": {
        additionalInfo = '';
        sessionStorage.removeItem('legcuuid');
        dispatch({
          type: "onSetTickerState",
          payload: {
            call_state: constants.CALL_STATES.CALL_HANGUP,
            hangup_reason: "self",
          },
        });
        break;
      }

      case "register_error": {
        dispatch({
          type: "onSetTickerState",
          payload: { sip_connected: false, sip_tried: true },
        });
        break;
      }

      case "rejected": {
        dispatch({
          type: "onSetTickerState",
          payload: { call_state: constants.CALL_STATES.CALL_HANGUP, 
            // sip_event_info: {} 
          },
        });
        break;
      }

      case "error_accept_reject": {
        dispatch({
          type: "onSetTickerState",
          payload: { call_state: constants.CALL_STATES.CALL_HANGUP },
        });
        break;
      }

      case "unregistered": {
        dispatch({
          type: "onSetTickerState",
          payload: { sip_connected: false, sip_tried: true },
        });
        dispatch({ type: "Close", payload: {} });
        break;
      }

      case "invited": {
        if(!userMediaEnabled) {
          broadcastEvents("MICROPHONE", '', '');
          setToastInfo((prevState) => ({
            ...prevState,
            open: true,
            snackbarMessage: `Error! Microphone not detected. Connect Microphone to answer calls.`,
            severity: "error",
          }));
          notifyCallEvent({ type: "register_error" });
          return;
        }
        const eventData = { ...event.event_info };
        const eventCustomData = eventEngineDataObject(eventData);

        delete event.event_info;        
        dispatch({
          type: "onCallStateChange",
          payload: { sip_call_event_type: event.type, sip_call_event: event, sip_event_info: eventData },
        });
         eventCustomData && callSIPEventEngine(Object.values(eventCustomData)[0], dispatch);
        break;
      }

      case "muted": {
        const payload = {};
        payload[constants.CALL_COMMANDS.MUTE] = constants.MUTE_STATES.ON_MUTE;
        dispatch({ type: "onCallStateChange", payload: payload });
        break;
      }

      case "unmuted": {
        const payload = {};
        payload[constants.CALL_COMMANDS.MUTE] =
          constants.MUTE_STATES.NOT_ON_MUTE;
        dispatch({ type: "onCallStateChange", payload: payload });
        break;
      }

      default:
        return;
    }
  };

  useEffect(() => {
    if (!is_mpls || !store.getState().auth.kamailio_wss_domain) {
      return;
    }
  
    // abort user register, if user media is not allowed.
    if(!userMediaEnabled) {
      broadcastEvents("MICROPHONE", '', '');
      setToastInfo((prevState) => ({
        ...prevState,
        open: true,
        snackbarMessage: `Error! Microphone not detected. Connect Microphone to answer calls.`,
        severity: "error",
      }));
      notifyCallEvent({ type: "register_error" });
      return;
    }
  
    const setupSIP = async () => {
      if (phone_switch_state === "sip" && !store.getState().ticker.sip_connected) {
        await initialize();
        if (window.iceServers) {
          if (!store.getState().auth.kamailio_username || 
              !store.getState().auth.kamailio_password || 
              !store.getState().auth.kamailio_wss_domain) {
              setToastInfo((prevState) => ({
                ...prevState,
                open: true,
                snackbarMessage: `Error! User details not found.`,
                severity: "error",
              }));
              return;
          }
          const userAgentSettings = getSIPUserAgentSettings(sipAgent);
          softphone(
            user,
            { type: "set-user", payload: userAgentSettings },
            notifyCallEvent,
            eventBasedNotifyCallEvent
          );
        }
      }
    };
  
    setupSIP();
  }, [
    is_mpls,
    phone_switch_state,
    phone_switch_state_changed,
    sipAgent,
    is_sso,
    is_sip_user_acknowledged,
    sip_retry,
    // Since initialize() and window.iceServers are dependencies
  ]);
  

  useEffect(() => {
    if (!is_mpls) return;

    if (sip_command && phone_switch_state === "sip") {
      if (!sipAgent) {
        console.error("webrtc sipAgent null", null);
        return;
      }
      const command = { ...sip_command };
      if (!user) {
        console.warn("softphone webrtc user null while calling command::");
      }
      softphone(
        user, 
        command, 
        notifyCallEvent,
        eventBasedNotifyCallEvent);
    } else {
    }
  }, [sip_command]);

  useEffect(() => {
    
    if (!is_mpls) {
        return;
    }
    const handleBeforeUnload = (e) => {
        if (user)
        {
            console.warn(`[beforeunload] Attempting to hangup active SIP session in state: ${user}`);

            try {
                 softphone(
                  user,
                    { type: "hangup" },
                    notifyCallEvent, 
                    eventBasedNotifyCallEvent
                );
                console.log("[beforeunload] Hangup command sent via softphone.");

            } catch (error) {
                console.error("[beforeunload] Error attempting to hangup via softphone:", error);
            }
        } else {
             console.log("[beforeunload] No active user/session found or session not in active state.");
        }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    console.log("Added beforeunload listener for SIP hangup.");
    return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        console.log("Removed beforeunload listener for SIP hangup.");
    };
  }, [user]);

  return (
    <>
      <ConfigurationToastMessage
        severity={toastInfo.severity}
        snackbarMessage={toastInfo.snackbarMessage}
        open={toastInfo.open}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      {is_mpls && !is_sip_user_acknowledged && user && <AlertDialog />}
      {/* commenting it to avoid unneccesary calls to manifest.json */}
      {/* <ConnectionCheck /> */}
    </>
  );
};
